import { render, staticRenderFns } from "./DataTables.vue?vue&type=template&id=926d5bbe"
import script from "./DataTables.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTables.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('926d5bbe')) {
      api.createRecord('926d5bbe', component.options)
    } else {
      api.reload('926d5bbe', component.options)
    }
    module.hot.accept("./DataTables.vue?vue&type=template&id=926d5bbe", function () {
      api.rerender('926d5bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tables/DataTables.vue"
export default component.exports